/** Stub for CDN bundle */
const noop = () => {};
const empty = () => null;
export default {
  get: empty,
  set: noop,
  getPersistent: empty,
  setPersistent: noop,
  removePersistent: noop,
  removeSession: noop,
};
